export const constant = {
	bigNumber: 1e5,
	drugLicenseRegex: /^([^\d]*\d){12}[^\d]*$/,
	panCardRegex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
	emailRegex: /\S+@\S+\.\S+/,
	gstRegex: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[A-Z0-9]{1}Z[A-Z0-9]{1}$/,
};

export const CREDIT_NOTE_TYPE = {
	1: 'Damaged/Returned Goods',
	2: 'Excess Payment',
	3: 'Advance Payment',
};

export const productStatusList = [
	'Inactive Products',
	'Low Stocks Products',
	'Out Of Stocks',
	'Excess Stocks',
	'Near Expiry Stocks',
	'Expired Stocks',
];

export const checkProductStatus = (tag) => {
	switch (tag) {
		case 'Low Stocks Products':
			return 'low_stock';
		case 'Out Of Stocks':
			return 'out_of_stock';
		case 'Expired Stocks':
			return 'expired';
		case 'Near Expiry Stocks':
			return 'near_expiry';
		case 'excess_stock':
			return 'Excess Stock';
		case 'Inactive Products':
			return 'inactive';
		default:
			return tag;
	}
};
export const formatTag = (tag) => {
	switch (tag) {
		case 'low_stock':
			return 'Low Stock';
		case 'out_of_stock':
			return 'Product Out of Stock';
		case 'expired':
			return 'Batch Expired';
		case 'near_expiry':
			return 'Batch Near Expiring';
		case 'excess_stock':
			return 'Excess Stock';
		case 'inactive':
			return 'Inactive';
		default:
			return tag;
	}
};
export const colorFormatTag = (tag) => {
	switch (tag) {
		case 'low_stock':
			return '#E7E3B4';
		case 'out_of_stock':
			return '#FFEED5';
		case 'expired':
			return '#FCCFCF';
		case 'near_expiry':
			return '#FFEDED';
		case 'excess_stock':
			return '#BEE8E2';
		default:
			return '#718096';
	}
};

export function generateArray(limit) {
	return Array.from({ length: limit }, (_, i) => ({
		key: i,
		value: i,
	}));
}
export const isNumber = (id) => {
	return typeof id === 'number' && !Number.isNaN(id);
};
